module.exports = __webpack_public_path__ + "04_veryshort_black.0c4408bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_veryshort_black.png
// module id = OoTV
// module chunks = 0